
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/view-in-app",
      function () {
        return require("private-next-pages/app/view-in-app/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/view-in-app"])
      });
    }
  